import { Input } from "components";
import React, { useState } from 'react';
import { useNavigate } from "react-router";
import { userforgotPassword } from 'services';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Typography, Snackbar, Stack } from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { EurofinsLogo } from "components/svg/EurofinsLogo";
import { ElvisConnect } from "components/svg/ElvisConnect";

export const ForgotPassword = () => {
    let navigate = useNavigate();
    const [userName, setUserName] = useState();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);
    const [lockedError, setLockedError] = useState(false);
    const [isDisableButton, setIsDisableButton] = useState(false);
    const [lockedErrorMessage, setLockedErrorMessage] = useState('');

    const sendOtp = (e: any) => {
        e.preventDefault();
        setLoading(true);
        userforgotPassword(userName).then((res: any) => {
            if (res.status === 200) {
                setOpen(true);
                setTimeout(() => {
                    setOpen(false);
                    navigate('/otp', { state: { data: userName } });
                }, 6000)
                setLoading(false);
                setError(false);
                setLockedError(false);
                setIsDisableButton(false);
            } else if (res?.status === 423) {
                setLockedError(true);
                setIsDisableButton(false);
                setTimeout(() => setIsDisableButton(false), 3000);
                setLockedErrorMessage(res?.data);
            } else {
                setError(true);
                setLockedError(false);
                setIsDisableButton(false);
            }
        }).finally(() => {
            setLoading(false);
        })
    }

    const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
        props,
        ref,
    ) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <div style={{ minHeight: '100vh', width: '100%', background: 'linear-gradient(to right, #003883, #ee7d11)' }}>
            <form onSubmit={sendOtp} style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                margin: 0,
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    p: 3,
                    m: 1,
                    width: '400px',
                    bgcolor: 'background.paper',
                    borderRadius: 1,
                }}>
                    <div><EurofinsLogo /></div>
                    <div><ElvisConnect /></div>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 1,
                            m: 1,
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                        }}
                    >
                        <Typography variant="h6" data-testid="forgot-title" color="secondary.main">Forgot Password</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-end',
                            justifyContent: 'center',
                            p: 1,
                            width: '100%',
                            m: 1,
                            borderRadius: 1,
                        }}
                    >
                        <Input
                            inputProps={{
                                "data-testid": 'email-field',
                            }}
                            type="email"
                            fullWidth={true}
                            required onChange={(ev) => setUserName(ev.target.value)}
                            label="Email Id"
                        />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 1,
                            width: '100%',
                            bgcolor: 'background.paper',
                            borderRadius: 1,
                        }}
                    >
                        <LoadingButton role="generate-otp" loading={loading} type="submit" sx={{ m: 1 }} style={{ width: '40%' }} variant="contained" disabled={isDisableButton}>
                            Generate OTP
                        </LoadingButton>
                    </Box>
                </Box>
            </form>
            <Stack>
                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                    <Alert onClose={handleClose} severity="success">
                        Please check your email for password reset instructions.
                    </Alert>
                </Snackbar>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert onClose={() => setError(false)} severity="warning">
                        Something went wrong please try again
                    </Alert>
                </Snackbar>
                <Snackbar open={lockedError} autoHideDuration={8000} onClose={() => setLockedError(false)}>
                    <Alert onClose={() => setLockedError(false)} severity="warning">
                        {lockedErrorMessage}
                    </Alert>
                </Snackbar>
            </Stack>
        </div>
    )
}
